import { useEffect, useState } from "react";
import axiosInstance from "../../../../axiosInstance";

const TermsAndConditions = (props) => {
  const [TermsHTML, setTermsHTML] = useState("");

  useEffect(() => {
    fetchTermsAndConditions();
    if (props.isMobileOrTablet) {
      document.getElementById("mobile-nav").style.opacity = "0";

      return () => {
        document.getElementById("mobile-nav").style.opacity = "1";
      };
    }
  }, []);

  const fetchTermsAndConditions = () => {
    let Req = {
      method: "GET",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/api/legal-infos/TERMS_AND_CONDITIONS",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axiosInstance(Req)
      .then((Res) => {
        console.log(Res);
        setTermsHTML(Res.data.content);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  return (
    <div className="terms-wrapper">
      <h1 className="terms-title">Terms, Payment and Data Privacy</h1>
      <div
        className="terms-text-wrapper mobile-terms-wrapper"
        dangerouslySetInnerHTML={{ __html: TermsHTML }}
      ></div>
      {props.isMobileOrTablet ? (
        <div className="mobile-back-btn" onClick={() => window.history.back()}>
          Close
        </div>
      ) : (
        <span className="back-btn" onClick={() => window.history.back()}>
          Close
        </span>
      )}
    </div>
  );
};

export default TermsAndConditions;
